import { render, staticRenderFns } from "./FroalaEditor.vue?vue&type=template&id=39ef408a&"
import script from "./FroalaEditor.vue?vue&type=script&lang=js&"
export * from "./FroalaEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports